// import imageSlider from '../../_organisms/imageSlider/_script';

/**
 * accordion
 */

const accordion = {
    cfg:  {
        name: 'accordion',
        triggers: [...document.querySelectorAll('.js-accordeonTrigger')],
        status: 'is-open'
    },

    // Toggle Content
    toggleAccordeon(event) {
        event.preventDefault();
        const target = event.currentTarget;
        const tabContent = document.getElementById(target.dataset.tab); // target.nextElementSibling;
        const allTabs = document.querySelectorAll('.js-accordeonContent');

        if (!target.classList.contains(this.cfg.status)) {
            allTabs.forEach((tab) => {
                tab.classList.remove(this.cfg.status);
            });
            this.cfg.triggers.forEach((trigger) => {
                trigger.classList.remove(this.cfg.status);
            });
            target.classList.add(this.cfg.status);
            tabContent.classList.add(this.cfg.status);

            // imageSlider.refreshSlider();
        } else {
            allTabs.forEach((tab) => {
                tab.classList.remove(this.cfg.status);
            });
            this.cfg.triggers.forEach((trigger) => {
                trigger.classList.remove(this.cfg.status);
            });
        }
    },

    init() {
        this.cfg.triggers.forEach((trigger) => {
            trigger.addEventListener('click', (event) => {
                this.toggleAccordeon(event);
            });
        });
    }
};

export default accordion;



// WEBPACK FOOTER //
// ./___src/templates/_organisms/accordion/_script.js